import React, { useState } from 'react';
import faqShape1 from '../../assets/images/shapes/faq-two-bg-shape.png';
import faqImg from '../../assets/images/artwer/project-3-galerij-amsterdam.jpg';
import faqImgWebp from '../../assets/images/artwer/project-3-galerij-amsterdam.webp';

const faqs = [
  {
    question: 'Wat kost een opname of inspectie?',
    answer: 'Een opname op locatie is vrijblijvend en kosteloos. U zit nergens aan vast en krijgt eerlijk advies over wat nú moet en wat (nog) kan wachten — handig als onderbouwing voor uw onderhoudsplanning.',
  },
  {
    question: 'Met welke techniek werken jullie?',
    answer: 'Voor waterdichting gebruiken wij het Soprema ALSAN® PMMA-systeem: een professioneel vloeibaar membraan, snel uithardend en bestand tegen UV en weersinvloeden. Bewezen techniek voor balkons en galerijen.',
  },
  {
    question: 'Hoe beperken jullie de overlast?',
    answer: 'Wij stemmen de planning met u af, werken netjes en houden balkons of looppaden zo kort mogelijk buiten gebruik. Eén vaste opleverdatum en geen onaangekondigd meerwerk.',
  },
];

export default function FAQTwo() {
  const [isActive, setIsActive] = useState({ status: false, key: 1 });

  const handleToggle = (key) => {
    if (isActive.key === key) {
      setIsActive({ status: false });
    } else {
      setIsActive({ status: true, key });
    }
  };

  return (
    <>
      <section className="faq-two">
        <div className="faq-two__wrap">
          <div
            className="faq-two__bg-shape"
              style={{ backgroundImage: `url(${faqShape1})` }}
          ></div>
          <div className="container">
            <div className="row">
              <div className="col-xl-6">
                <div className="faq-two__left">
                  <div className="faq-two__img">
                    <picture>
                      <source srcSet={faqImgWebp} type="image/webp" />
                      <img src={faqImg} alt="Opgeleverde galerijvloer in Amsterdam" width="1467" height="1100" loading="lazy" />
                    </picture>
                  </div>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="faq-two__right">
                  <div className="section-title text-left">
                    <div className="section-title__tagline-box">
                      <span className="section-title__tagline">Veelgestelde vragen</span>
                    </div>
                    <h2 className="section-title__title">
                      Antwoord op uw <br /><span>vragen</span>
                    </h2>
                  </div>
                  <div
                    className="accrodion-grp faq-one-accrodion"
                    data-grp-name="faq-one-accrodion-1"
                  >
                    {faqs.map((item, index) => {
                      const open = isActive.key === index + 1;
                      return (
                        <div key={index} className={`accrodion ${open ? 'active' : ''}`}>
                          <button
                            type="button"
                            id={`faq-trigger-${index + 1}`}
                            className="accrodion-title"
                            onClick={() => handleToggle(index + 1)}
                            aria-expanded={open}
                            aria-controls={`faq-panel-${index + 1}`}
                          >
                            <div className="faq-two__count" aria-hidden="true"></div>
                            <h3>{item.question}</h3>
                          </button>
                          <div
                            id={`faq-panel-${index + 1}`}
                            role="region"
                            aria-labelledby={`faq-trigger-${index + 1}`}
                            className={`accrodion-content ${open ? 'show' : ''}`}
                          >
                            <div className="inner">
                              <p>{item.answer}</p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
